/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as indexRouteImport } from './routes/index'
import { Route as tLayoutRouteImport } from './routes/t/layout'
import { Route as connectRouteImport } from './routes/connect'
import { Route as loginRouteImport } from './routes/login'
import { Route as registerRouteImport } from './routes/register'
import { Route as devComponentsRouteImport } from './routes/dev-components'
import { Route as helpEntryRouteImport } from './routes/help-entry'
import { Route as inviteRouteImport } from './routes/invite'
import { Route as passwordForgotRouteImport } from './routes/password/forgot'
import { Route as passwordResetRouteImport } from './routes/password/reset'
import { Route as registerVerifyRouteImport } from './routes/register-verify'
import { Route as resetTokenRouteImport } from './routes/reset/$token'
import { Route as tDashboardRouteImport } from './routes/t/dashboard'
import { Route as tAiRouteImport } from './routes/t/ai'
import { Route as tAnalyticsRouteImport } from './routes/t/analytics'
import { Route as tArchiveRouteImport } from './routes/t/archive'
import { Route as tCatchupRouteImport } from './routes/t/catchup'
import { Route as tContributionRouteImport } from './routes/t/contribution'
import { Route as tDeliveryRouteImport } from './routes/t/delivery'
import { Route as tEntitiesRouteImport } from './routes/t/entities'
import { Route as tEpgRouteImport } from './routes/t/epg'
import { Route as tFastRouteImport } from './routes/t/fast'
import { Route as tHelpRouteImport } from './routes/t/help'
import { Route as tIntegrationsRouteImport } from './routes/t/integrations'
import { Route as tLibraryRouteImport } from './routes/t/library'
import { Route as tLiveRouteImport } from './routes/t/live'
import { Route as tMonitoringRouteImport } from './routes/t/monitoring'
import { Route as tPlayersRouteImport } from './routes/t/players'
import { Route as tSeriesRouteImport } from './routes/t/series'
import { Route as tSettingsRouteImport } from './routes/t/settings'
import { Route as tSitesRouteImport } from './routes/t/sites'
import { Route as tStorageRouteImport } from './routes/t/storage'
import { Route as tSupportRouteImport } from './routes/t/support'
import { Route as tTeamRouteImport } from './routes/t/team'
import { Route as tViewersRouteImport } from './routes/t/viewers'
import { Route as tHelpTopicRouteImport } from './routes/t/help-topic'
import { Route as tAssetRouteImport } from './routes/t/asset'
import { Route as tTrashRouteImport } from './routes/t/trash'
import { Route as tChannelRouteImport } from './routes/t/channel'
import { Route as tPlayersCrashesRouteImport } from './routes/t/players-crashes'
import { Route as tPlayersTvRouteImport } from './routes/t/players-tv'
import { Route as tSupportRequestRouteImport } from './routes/t/support-request'
import { Route as tViewerRouteImport } from './routes/t/viewer'
import { Route as tViewersAuditRouteImport } from './routes/t/viewers-audit'
import { Route as tViewersRequestsRouteImport } from './routes/t/viewers-requests'
import { Route as tViewersSegmentsRouteImport } from './routes/t/viewers-segments'
import { Route as tViewersSettingsRouteImport } from './routes/t/viewers-settings'
import { Route as tSiteEditorRouteImport } from './routes/t/site-editor'

const indexRoute = indexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const tLayoutRoute = tLayoutRouteImport.update({
  id: '/_layout',
  getParentRoute: () => rootRouteImport,
} as any)
const connectRoute = connectRouteImport.update({
  id: '/connect',
  path: '/connect',
  getParentRoute: () => rootRouteImport,
} as any)
const loginRoute = loginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const registerRoute = registerRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const devComponentsRoute = devComponentsRouteImport.update({
  id: '/dev/components',
  path: '/dev/components',
  getParentRoute: () => rootRouteImport,
} as any)
const helpEntryRoute = helpEntryRouteImport.update({
  id: '/help/$topic',
  path: '/help/$topic',
  getParentRoute: () => rootRouteImport,
} as any)
const inviteRoute = inviteRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const passwordForgotRoute = passwordForgotRouteImport.update({
  id: '/password/forgot',
  path: '/password/forgot',
  getParentRoute: () => rootRouteImport,
} as any)
const passwordResetRoute = passwordResetRouteImport.update({
  id: '/password/reset',
  path: '/password/reset',
  getParentRoute: () => rootRouteImport,
} as any)
const registerVerifyRoute = registerVerifyRouteImport.update({
  id: '/register/verify',
  path: '/register/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const resetTokenRoute = resetTokenRouteImport.update({
  id: '/reset/$token',
  path: '/reset/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const tDashboardRoute = tDashboardRouteImport.update({
  id: '/t/$slug',
  path: '/t/$slug',
  getParentRoute: () => tLayoutRoute,
} as any)
const tAiRoute = tAiRouteImport.update({
  id: '/t/$slug/ai',
  path: '/t/$slug/ai',
  getParentRoute: () => tLayoutRoute,
} as any)
const tAnalyticsRoute = tAnalyticsRouteImport.update({
  id: '/t/$slug/analytics',
  path: '/t/$slug/analytics',
  getParentRoute: () => tLayoutRoute,
} as any)
const tArchiveRoute = tArchiveRouteImport.update({
  id: '/t/$slug/archive',
  path: '/t/$slug/archive',
  getParentRoute: () => tLayoutRoute,
} as any)
const tCatchupRoute = tCatchupRouteImport.update({
  id: '/t/$slug/catchup',
  path: '/t/$slug/catchup',
  getParentRoute: () => tLayoutRoute,
} as any)
const tContributionRoute = tContributionRouteImport.update({
  id: '/t/$slug/contribution',
  path: '/t/$slug/contribution',
  getParentRoute: () => tLayoutRoute,
} as any)
const tDeliveryRoute = tDeliveryRouteImport.update({
  id: '/t/$slug/delivery',
  path: '/t/$slug/delivery',
  getParentRoute: () => tLayoutRoute,
} as any)
const tEntitiesRoute = tEntitiesRouteImport.update({
  id: '/t/$slug/entities',
  path: '/t/$slug/entities',
  getParentRoute: () => tLayoutRoute,
} as any)
const tEpgRoute = tEpgRouteImport.update({
  id: '/t/$slug/epg',
  path: '/t/$slug/epg',
  getParentRoute: () => tLayoutRoute,
} as any)
const tFastRoute = tFastRouteImport.update({
  id: '/t/$slug/fast',
  path: '/t/$slug/fast',
  getParentRoute: () => tLayoutRoute,
} as any)
const tHelpRoute = tHelpRouteImport.update({
  id: '/t/$slug/help',
  path: '/t/$slug/help',
  getParentRoute: () => tLayoutRoute,
} as any)
const tIntegrationsRoute = tIntegrationsRouteImport.update({
  id: '/t/$slug/integrations',
  path: '/t/$slug/integrations',
  getParentRoute: () => tLayoutRoute,
} as any)
const tLibraryRoute = tLibraryRouteImport.update({
  id: '/t/$slug/library',
  path: '/t/$slug/library',
  getParentRoute: () => tLayoutRoute,
} as any)
const tLiveRoute = tLiveRouteImport.update({
  id: '/t/$slug/live',
  path: '/t/$slug/live',
  getParentRoute: () => tLayoutRoute,
} as any)
const tMonitoringRoute = tMonitoringRouteImport.update({
  id: '/t/$slug/monitoring',
  path: '/t/$slug/monitoring',
  getParentRoute: () => tLayoutRoute,
} as any)
const tPlayersRoute = tPlayersRouteImport.update({
  id: '/t/$slug/players',
  path: '/t/$slug/players',
  getParentRoute: () => tLayoutRoute,
} as any)
const tSeriesRoute = tSeriesRouteImport.update({
  id: '/t/$slug/series',
  path: '/t/$slug/series',
  getParentRoute: () => tLayoutRoute,
} as any)
const tSettingsRoute = tSettingsRouteImport.update({
  id: '/t/$slug/settings',
  path: '/t/$slug/settings',
  getParentRoute: () => tLayoutRoute,
} as any)
const tSitesRoute = tSitesRouteImport.update({
  id: '/t/$slug/sites',
  path: '/t/$slug/sites',
  getParentRoute: () => tLayoutRoute,
} as any)
const tStorageRoute = tStorageRouteImport.update({
  id: '/t/$slug/storage',
  path: '/t/$slug/storage',
  getParentRoute: () => tLayoutRoute,
} as any)
const tSupportRoute = tSupportRouteImport.update({
  id: '/t/$slug/support',
  path: '/t/$slug/support',
  getParentRoute: () => tLayoutRoute,
} as any)
const tTeamRoute = tTeamRouteImport.update({
  id: '/t/$slug/team',
  path: '/t/$slug/team',
  getParentRoute: () => tLayoutRoute,
} as any)
const tViewersRoute = tViewersRouteImport.update({
  id: '/t/$slug/viewers',
  path: '/t/$slug/viewers',
  getParentRoute: () => tLayoutRoute,
} as any)
const tHelpTopicRoute = tHelpTopicRouteImport.update({
  id: '/t/$slug/help/$topic',
  path: '/t/$slug/help/$topic',
  getParentRoute: () => tLayoutRoute,
} as any)
const tAssetRoute = tAssetRouteImport.update({
  id: '/t/$slug/library/$assetId',
  path: '/t/$slug/library/$assetId',
  getParentRoute: () => tLayoutRoute,
} as any)
const tTrashRoute = tTrashRouteImport.update({
  id: '/t/$slug/library/trash',
  path: '/t/$slug/library/trash',
  getParentRoute: () => tLayoutRoute,
} as any)
const tChannelRoute = tChannelRouteImport.update({
  id: '/t/$slug/live/$channelId',
  path: '/t/$slug/live/$channelId',
  getParentRoute: () => tLayoutRoute,
} as any)
const tPlayersCrashesRoute = tPlayersCrashesRouteImport.update({
  id: '/t/$slug/players/crashes',
  path: '/t/$slug/players/crashes',
  getParentRoute: () => tLayoutRoute,
} as any)
const tPlayersTvRoute = tPlayersTvRouteImport.update({
  id: '/t/$slug/players/tv',
  path: '/t/$slug/players/tv',
  getParentRoute: () => tLayoutRoute,
} as any)
const tSupportRequestRoute = tSupportRequestRouteImport.update({
  id: '/t/$slug/support/$requestId',
  path: '/t/$slug/support/$requestId',
  getParentRoute: () => tLayoutRoute,
} as any)
const tViewerRoute = tViewerRouteImport.update({
  id: '/t/$slug/viewers/$viewerId',
  path: '/t/$slug/viewers/$viewerId',
  getParentRoute: () => tLayoutRoute,
} as any)
const tViewersAuditRoute = tViewersAuditRouteImport.update({
  id: '/t/$slug/viewers/audit',
  path: '/t/$slug/viewers/audit',
  getParentRoute: () => tLayoutRoute,
} as any)
const tViewersRequestsRoute = tViewersRequestsRouteImport.update({
  id: '/t/$slug/viewers/requests',
  path: '/t/$slug/viewers/requests',
  getParentRoute: () => tLayoutRoute,
} as any)
const tViewersSegmentsRoute = tViewersSegmentsRouteImport.update({
  id: '/t/$slug/viewers/segments',
  path: '/t/$slug/viewers/segments',
  getParentRoute: () => tLayoutRoute,
} as any)
const tViewersSettingsRoute = tViewersSettingsRouteImport.update({
  id: '/t/$slug/viewers/settings',
  path: '/t/$slug/viewers/settings',
  getParentRoute: () => tLayoutRoute,
} as any)
const tSiteEditorRoute = tSiteEditorRouteImport.update({
  id: '/t/$slug/sites/$siteId/pages/$pageId',
  path: '/t/$slug/sites/$siteId/pages/$pageId',
  getParentRoute: () => tLayoutRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof indexRoute
  '/connect': typeof connectRoute
  '/login': typeof loginRoute
  '/register': typeof registerRoute
  '/dev/components': typeof devComponentsRoute
  '/help/$topic': typeof helpEntryRoute
  '/invite/$token': typeof inviteRoute
  '/password/forgot': typeof passwordForgotRoute
  '/password/reset': typeof passwordResetRoute
  '/register/verify': typeof registerVerifyRoute
  '/reset/$token': typeof resetTokenRoute
  '/t/$slug': typeof tDashboardRoute
  '/t/$slug/ai': typeof tAiRoute
  '/t/$slug/analytics': typeof tAnalyticsRoute
  '/t/$slug/archive': typeof tArchiveRoute
  '/t/$slug/catchup': typeof tCatchupRoute
  '/t/$slug/contribution': typeof tContributionRoute
  '/t/$slug/delivery': typeof tDeliveryRoute
  '/t/$slug/entities': typeof tEntitiesRoute
  '/t/$slug/epg': typeof tEpgRoute
  '/t/$slug/fast': typeof tFastRoute
  '/t/$slug/help': typeof tHelpRoute
  '/t/$slug/integrations': typeof tIntegrationsRoute
  '/t/$slug/library': typeof tLibraryRoute
  '/t/$slug/live': typeof tLiveRoute
  '/t/$slug/monitoring': typeof tMonitoringRoute
  '/t/$slug/players': typeof tPlayersRoute
  '/t/$slug/series': typeof tSeriesRoute
  '/t/$slug/settings': typeof tSettingsRoute
  '/t/$slug/sites': typeof tSitesRoute
  '/t/$slug/storage': typeof tStorageRoute
  '/t/$slug/support': typeof tSupportRoute
  '/t/$slug/team': typeof tTeamRoute
  '/t/$slug/viewers': typeof tViewersRoute
  '/t/$slug/help/$topic': typeof tHelpTopicRoute
  '/t/$slug/library/$assetId': typeof tAssetRoute
  '/t/$slug/library/trash': typeof tTrashRoute
  '/t/$slug/live/$channelId': typeof tChannelRoute
  '/t/$slug/players/crashes': typeof tPlayersCrashesRoute
  '/t/$slug/players/tv': typeof tPlayersTvRoute
  '/t/$slug/support/$requestId': typeof tSupportRequestRoute
  '/t/$slug/viewers/$viewerId': typeof tViewerRoute
  '/t/$slug/viewers/audit': typeof tViewersAuditRoute
  '/t/$slug/viewers/requests': typeof tViewersRequestsRoute
  '/t/$slug/viewers/segments': typeof tViewersSegmentsRoute
  '/t/$slug/viewers/settings': typeof tViewersSettingsRoute
  '/t/$slug/sites/$siteId/pages/$pageId': typeof tSiteEditorRoute
}
export interface FileRoutesByTo {
  '/': typeof indexRoute
  '/connect': typeof connectRoute
  '/login': typeof loginRoute
  '/register': typeof registerRoute
  '/dev/components': typeof devComponentsRoute
  '/help/$topic': typeof helpEntryRoute
  '/invite/$token': typeof inviteRoute
  '/password/forgot': typeof passwordForgotRoute
  '/password/reset': typeof passwordResetRoute
  '/register/verify': typeof registerVerifyRoute
  '/reset/$token': typeof resetTokenRoute
  '/t/$slug': typeof tDashboardRoute
  '/t/$slug/ai': typeof tAiRoute
  '/t/$slug/analytics': typeof tAnalyticsRoute
  '/t/$slug/archive': typeof tArchiveRoute
  '/t/$slug/catchup': typeof tCatchupRoute
  '/t/$slug/contribution': typeof tContributionRoute
  '/t/$slug/delivery': typeof tDeliveryRoute
  '/t/$slug/entities': typeof tEntitiesRoute
  '/t/$slug/epg': typeof tEpgRoute
  '/t/$slug/fast': typeof tFastRoute
  '/t/$slug/help': typeof tHelpRoute
  '/t/$slug/integrations': typeof tIntegrationsRoute
  '/t/$slug/library': typeof tLibraryRoute
  '/t/$slug/live': typeof tLiveRoute
  '/t/$slug/monitoring': typeof tMonitoringRoute
  '/t/$slug/players': typeof tPlayersRoute
  '/t/$slug/series': typeof tSeriesRoute
  '/t/$slug/settings': typeof tSettingsRoute
  '/t/$slug/sites': typeof tSitesRoute
  '/t/$slug/storage': typeof tStorageRoute
  '/t/$slug/support': typeof tSupportRoute
  '/t/$slug/team': typeof tTeamRoute
  '/t/$slug/viewers': typeof tViewersRoute
  '/t/$slug/help/$topic': typeof tHelpTopicRoute
  '/t/$slug/library/$assetId': typeof tAssetRoute
  '/t/$slug/library/trash': typeof tTrashRoute
  '/t/$slug/live/$channelId': typeof tChannelRoute
  '/t/$slug/players/crashes': typeof tPlayersCrashesRoute
  '/t/$slug/players/tv': typeof tPlayersTvRoute
  '/t/$slug/support/$requestId': typeof tSupportRequestRoute
  '/t/$slug/viewers/$viewerId': typeof tViewerRoute
  '/t/$slug/viewers/audit': typeof tViewersAuditRoute
  '/t/$slug/viewers/requests': typeof tViewersRequestsRoute
  '/t/$slug/viewers/segments': typeof tViewersSegmentsRoute
  '/t/$slug/viewers/settings': typeof tViewersSettingsRoute
  '/t/$slug/sites/$siteId/pages/$pageId': typeof tSiteEditorRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof indexRoute
  '/_layout': typeof tLayoutRouteWithChildren
  '/connect': typeof connectRoute
  '/login': typeof loginRoute
  '/register': typeof registerRoute
  '/dev/components': typeof devComponentsRoute
  '/help/$topic': typeof helpEntryRoute
  '/invite/$token': typeof inviteRoute
  '/password/forgot': typeof passwordForgotRoute
  '/password/reset': typeof passwordResetRoute
  '/register/verify': typeof registerVerifyRoute
  '/reset/$token': typeof resetTokenRoute
  '/_layout/t/$slug': typeof tDashboardRoute
  '/_layout/t/$slug/ai': typeof tAiRoute
  '/_layout/t/$slug/analytics': typeof tAnalyticsRoute
  '/_layout/t/$slug/archive': typeof tArchiveRoute
  '/_layout/t/$slug/catchup': typeof tCatchupRoute
  '/_layout/t/$slug/contribution': typeof tContributionRoute
  '/_layout/t/$slug/delivery': typeof tDeliveryRoute
  '/_layout/t/$slug/entities': typeof tEntitiesRoute
  '/_layout/t/$slug/epg': typeof tEpgRoute
  '/_layout/t/$slug/fast': typeof tFastRoute
  '/_layout/t/$slug/help': typeof tHelpRoute
  '/_layout/t/$slug/integrations': typeof tIntegrationsRoute
  '/_layout/t/$slug/library': typeof tLibraryRoute
  '/_layout/t/$slug/live': typeof tLiveRoute
  '/_layout/t/$slug/monitoring': typeof tMonitoringRoute
  '/_layout/t/$slug/players': typeof tPlayersRoute
  '/_layout/t/$slug/series': typeof tSeriesRoute
  '/_layout/t/$slug/settings': typeof tSettingsRoute
  '/_layout/t/$slug/sites': typeof tSitesRoute
  '/_layout/t/$slug/storage': typeof tStorageRoute
  '/_layout/t/$slug/support': typeof tSupportRoute
  '/_layout/t/$slug/team': typeof tTeamRoute
  '/_layout/t/$slug/viewers': typeof tViewersRoute
  '/_layout/t/$slug/help/$topic': typeof tHelpTopicRoute
  '/_layout/t/$slug/library/$assetId': typeof tAssetRoute
  '/_layout/t/$slug/library/trash': typeof tTrashRoute
  '/_layout/t/$slug/live/$channelId': typeof tChannelRoute
  '/_layout/t/$slug/players/crashes': typeof tPlayersCrashesRoute
  '/_layout/t/$slug/players/tv': typeof tPlayersTvRoute
  '/_layout/t/$slug/support/$requestId': typeof tSupportRequestRoute
  '/_layout/t/$slug/viewers/$viewerId': typeof tViewerRoute
  '/_layout/t/$slug/viewers/audit': typeof tViewersAuditRoute
  '/_layout/t/$slug/viewers/requests': typeof tViewersRequestsRoute
  '/_layout/t/$slug/viewers/segments': typeof tViewersSegmentsRoute
  '/_layout/t/$slug/viewers/settings': typeof tViewersSettingsRoute
  '/_layout/t/$slug/sites/$siteId/pages/$pageId': typeof tSiteEditorRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/connect'
    | '/login'
    | '/register'
    | '/dev/components'
    | '/help/$topic'
    | '/invite/$token'
    | '/password/forgot'
    | '/password/reset'
    | '/register/verify'
    | '/reset/$token'
    | '/t/$slug'
    | '/t/$slug/ai'
    | '/t/$slug/analytics'
    | '/t/$slug/archive'
    | '/t/$slug/catchup'
    | '/t/$slug/contribution'
    | '/t/$slug/delivery'
    | '/t/$slug/entities'
    | '/t/$slug/epg'
    | '/t/$slug/fast'
    | '/t/$slug/help'
    | '/t/$slug/integrations'
    | '/t/$slug/library'
    | '/t/$slug/live'
    | '/t/$slug/monitoring'
    | '/t/$slug/players'
    | '/t/$slug/series'
    | '/t/$slug/settings'
    | '/t/$slug/sites'
    | '/t/$slug/storage'
    | '/t/$slug/support'
    | '/t/$slug/team'
    | '/t/$slug/viewers'
    | '/t/$slug/help/$topic'
    | '/t/$slug/library/$assetId'
    | '/t/$slug/library/trash'
    | '/t/$slug/live/$channelId'
    | '/t/$slug/players/crashes'
    | '/t/$slug/players/tv'
    | '/t/$slug/support/$requestId'
    | '/t/$slug/viewers/$viewerId'
    | '/t/$slug/viewers/audit'
    | '/t/$slug/viewers/requests'
    | '/t/$slug/viewers/segments'
    | '/t/$slug/viewers/settings'
    | '/t/$slug/sites/$siteId/pages/$pageId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/connect'
    | '/login'
    | '/register'
    | '/dev/components'
    | '/help/$topic'
    | '/invite/$token'
    | '/password/forgot'
    | '/password/reset'
    | '/register/verify'
    | '/reset/$token'
    | '/t/$slug'
    | '/t/$slug/ai'
    | '/t/$slug/analytics'
    | '/t/$slug/archive'
    | '/t/$slug/catchup'
    | '/t/$slug/contribution'
    | '/t/$slug/delivery'
    | '/t/$slug/entities'
    | '/t/$slug/epg'
    | '/t/$slug/fast'
    | '/t/$slug/help'
    | '/t/$slug/integrations'
    | '/t/$slug/library'
    | '/t/$slug/live'
    | '/t/$slug/monitoring'
    | '/t/$slug/players'
    | '/t/$slug/series'
    | '/t/$slug/settings'
    | '/t/$slug/sites'
    | '/t/$slug/storage'
    | '/t/$slug/support'
    | '/t/$slug/team'
    | '/t/$slug/viewers'
    | '/t/$slug/help/$topic'
    | '/t/$slug/library/$assetId'
    | '/t/$slug/library/trash'
    | '/t/$slug/live/$channelId'
    | '/t/$slug/players/crashes'
    | '/t/$slug/players/tv'
    | '/t/$slug/support/$requestId'
    | '/t/$slug/viewers/$viewerId'
    | '/t/$slug/viewers/audit'
    | '/t/$slug/viewers/requests'
    | '/t/$slug/viewers/segments'
    | '/t/$slug/viewers/settings'
    | '/t/$slug/sites/$siteId/pages/$pageId'
  id:
    | '__root__'
    | '/'
    | '/_layout'
    | '/connect'
    | '/login'
    | '/register'
    | '/dev/components'
    | '/help/$topic'
    | '/invite/$token'
    | '/password/forgot'
    | '/password/reset'
    | '/register/verify'
    | '/reset/$token'
    | '/_layout/t/$slug'
    | '/_layout/t/$slug/ai'
    | '/_layout/t/$slug/analytics'
    | '/_layout/t/$slug/archive'
    | '/_layout/t/$slug/catchup'
    | '/_layout/t/$slug/contribution'
    | '/_layout/t/$slug/delivery'
    | '/_layout/t/$slug/entities'
    | '/_layout/t/$slug/epg'
    | '/_layout/t/$slug/fast'
    | '/_layout/t/$slug/help'
    | '/_layout/t/$slug/integrations'
    | '/_layout/t/$slug/library'
    | '/_layout/t/$slug/live'
    | '/_layout/t/$slug/monitoring'
    | '/_layout/t/$slug/players'
    | '/_layout/t/$slug/series'
    | '/_layout/t/$slug/settings'
    | '/_layout/t/$slug/sites'
    | '/_layout/t/$slug/storage'
    | '/_layout/t/$slug/support'
    | '/_layout/t/$slug/team'
    | '/_layout/t/$slug/viewers'
    | '/_layout/t/$slug/help/$topic'
    | '/_layout/t/$slug/library/$assetId'
    | '/_layout/t/$slug/library/trash'
    | '/_layout/t/$slug/live/$channelId'
    | '/_layout/t/$slug/players/crashes'
    | '/_layout/t/$slug/players/tv'
    | '/_layout/t/$slug/support/$requestId'
    | '/_layout/t/$slug/viewers/$viewerId'
    | '/_layout/t/$slug/viewers/audit'
    | '/_layout/t/$slug/viewers/requests'
    | '/_layout/t/$slug/viewers/segments'
    | '/_layout/t/$slug/viewers/settings'
    | '/_layout/t/$slug/sites/$siteId/pages/$pageId'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  indexRoute: typeof indexRoute
  tLayoutRoute: typeof tLayoutRouteWithChildren
  connectRoute: typeof connectRoute
  loginRoute: typeof loginRoute
  registerRoute: typeof registerRoute
  devComponentsRoute: typeof devComponentsRoute
  helpEntryRoute: typeof helpEntryRoute
  inviteRoute: typeof inviteRoute
  passwordForgotRoute: typeof passwordForgotRoute
  passwordResetRoute: typeof passwordResetRoute
  registerVerifyRoute: typeof registerVerifyRoute
  resetTokenRoute: typeof resetTokenRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof indexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof tLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/connect': {
      id: '/connect'
      path: '/connect'
      fullPath: '/connect'
      preLoaderRoute: typeof connectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof loginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof registerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dev/components': {
      id: '/dev/components'
      path: '/dev/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof devComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/help/$topic': {
      id: '/help/$topic'
      path: '/help/$topic'
      fullPath: '/help/$topic'
      preLoaderRoute: typeof helpEntryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invite/$token': {
      id: '/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof inviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password/forgot': {
      id: '/password/forgot'
      path: '/password/forgot'
      fullPath: '/password/forgot'
      preLoaderRoute: typeof passwordForgotRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/password/reset': {
      id: '/password/reset'
      path: '/password/reset'
      fullPath: '/password/reset'
      preLoaderRoute: typeof passwordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register/verify': {
      id: '/register/verify'
      path: '/register/verify'
      fullPath: '/register/verify'
      preLoaderRoute: typeof registerVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset/$token': {
      id: '/reset/$token'
      path: '/reset/$token'
      fullPath: '/reset/$token'
      preLoaderRoute: typeof resetTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_layout/t/$slug': {
      id: '/_layout/t/$slug'
      path: '/t/$slug'
      fullPath: '/t/$slug'
      preLoaderRoute: typeof tDashboardRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/ai': {
      id: '/_layout/t/$slug/ai'
      path: '/t/$slug/ai'
      fullPath: '/t/$slug/ai'
      preLoaderRoute: typeof tAiRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/analytics': {
      id: '/_layout/t/$slug/analytics'
      path: '/t/$slug/analytics'
      fullPath: '/t/$slug/analytics'
      preLoaderRoute: typeof tAnalyticsRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/archive': {
      id: '/_layout/t/$slug/archive'
      path: '/t/$slug/archive'
      fullPath: '/t/$slug/archive'
      preLoaderRoute: typeof tArchiveRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/catchup': {
      id: '/_layout/t/$slug/catchup'
      path: '/t/$slug/catchup'
      fullPath: '/t/$slug/catchup'
      preLoaderRoute: typeof tCatchupRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/contribution': {
      id: '/_layout/t/$slug/contribution'
      path: '/t/$slug/contribution'
      fullPath: '/t/$slug/contribution'
      preLoaderRoute: typeof tContributionRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/delivery': {
      id: '/_layout/t/$slug/delivery'
      path: '/t/$slug/delivery'
      fullPath: '/t/$slug/delivery'
      preLoaderRoute: typeof tDeliveryRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/entities': {
      id: '/_layout/t/$slug/entities'
      path: '/t/$slug/entities'
      fullPath: '/t/$slug/entities'
      preLoaderRoute: typeof tEntitiesRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/epg': {
      id: '/_layout/t/$slug/epg'
      path: '/t/$slug/epg'
      fullPath: '/t/$slug/epg'
      preLoaderRoute: typeof tEpgRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/fast': {
      id: '/_layout/t/$slug/fast'
      path: '/t/$slug/fast'
      fullPath: '/t/$slug/fast'
      preLoaderRoute: typeof tFastRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/help': {
      id: '/_layout/t/$slug/help'
      path: '/t/$slug/help'
      fullPath: '/t/$slug/help'
      preLoaderRoute: typeof tHelpRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/integrations': {
      id: '/_layout/t/$slug/integrations'
      path: '/t/$slug/integrations'
      fullPath: '/t/$slug/integrations'
      preLoaderRoute: typeof tIntegrationsRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/library': {
      id: '/_layout/t/$slug/library'
      path: '/t/$slug/library'
      fullPath: '/t/$slug/library'
      preLoaderRoute: typeof tLibraryRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/live': {
      id: '/_layout/t/$slug/live'
      path: '/t/$slug/live'
      fullPath: '/t/$slug/live'
      preLoaderRoute: typeof tLiveRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/monitoring': {
      id: '/_layout/t/$slug/monitoring'
      path: '/t/$slug/monitoring'
      fullPath: '/t/$slug/monitoring'
      preLoaderRoute: typeof tMonitoringRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/players': {
      id: '/_layout/t/$slug/players'
      path: '/t/$slug/players'
      fullPath: '/t/$slug/players'
      preLoaderRoute: typeof tPlayersRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/series': {
      id: '/_layout/t/$slug/series'
      path: '/t/$slug/series'
      fullPath: '/t/$slug/series'
      preLoaderRoute: typeof tSeriesRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/settings': {
      id: '/_layout/t/$slug/settings'
      path: '/t/$slug/settings'
      fullPath: '/t/$slug/settings'
      preLoaderRoute: typeof tSettingsRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/sites': {
      id: '/_layout/t/$slug/sites'
      path: '/t/$slug/sites'
      fullPath: '/t/$slug/sites'
      preLoaderRoute: typeof tSitesRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/storage': {
      id: '/_layout/t/$slug/storage'
      path: '/t/$slug/storage'
      fullPath: '/t/$slug/storage'
      preLoaderRoute: typeof tStorageRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/support': {
      id: '/_layout/t/$slug/support'
      path: '/t/$slug/support'
      fullPath: '/t/$slug/support'
      preLoaderRoute: typeof tSupportRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/team': {
      id: '/_layout/t/$slug/team'
      path: '/t/$slug/team'
      fullPath: '/t/$slug/team'
      preLoaderRoute: typeof tTeamRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/viewers': {
      id: '/_layout/t/$slug/viewers'
      path: '/t/$slug/viewers'
      fullPath: '/t/$slug/viewers'
      preLoaderRoute: typeof tViewersRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/help/$topic': {
      id: '/_layout/t/$slug/help/$topic'
      path: '/t/$slug/help/$topic'
      fullPath: '/t/$slug/help/$topic'
      preLoaderRoute: typeof tHelpTopicRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/library/$assetId': {
      id: '/_layout/t/$slug/library/$assetId'
      path: '/t/$slug/library/$assetId'
      fullPath: '/t/$slug/library/$assetId'
      preLoaderRoute: typeof tAssetRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/library/trash': {
      id: '/_layout/t/$slug/library/trash'
      path: '/t/$slug/library/trash'
      fullPath: '/t/$slug/library/trash'
      preLoaderRoute: typeof tTrashRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/live/$channelId': {
      id: '/_layout/t/$slug/live/$channelId'
      path: '/t/$slug/live/$channelId'
      fullPath: '/t/$slug/live/$channelId'
      preLoaderRoute: typeof tChannelRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/players/crashes': {
      id: '/_layout/t/$slug/players/crashes'
      path: '/t/$slug/players/crashes'
      fullPath: '/t/$slug/players/crashes'
      preLoaderRoute: typeof tPlayersCrashesRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/players/tv': {
      id: '/_layout/t/$slug/players/tv'
      path: '/t/$slug/players/tv'
      fullPath: '/t/$slug/players/tv'
      preLoaderRoute: typeof tPlayersTvRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/support/$requestId': {
      id: '/_layout/t/$slug/support/$requestId'
      path: '/t/$slug/support/$requestId'
      fullPath: '/t/$slug/support/$requestId'
      preLoaderRoute: typeof tSupportRequestRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/viewers/$viewerId': {
      id: '/_layout/t/$slug/viewers/$viewerId'
      path: '/t/$slug/viewers/$viewerId'
      fullPath: '/t/$slug/viewers/$viewerId'
      preLoaderRoute: typeof tViewerRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/viewers/audit': {
      id: '/_layout/t/$slug/viewers/audit'
      path: '/t/$slug/viewers/audit'
      fullPath: '/t/$slug/viewers/audit'
      preLoaderRoute: typeof tViewersAuditRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/viewers/requests': {
      id: '/_layout/t/$slug/viewers/requests'
      path: '/t/$slug/viewers/requests'
      fullPath: '/t/$slug/viewers/requests'
      preLoaderRoute: typeof tViewersRequestsRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/viewers/segments': {
      id: '/_layout/t/$slug/viewers/segments'
      path: '/t/$slug/viewers/segments'
      fullPath: '/t/$slug/viewers/segments'
      preLoaderRoute: typeof tViewersSegmentsRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/viewers/settings': {
      id: '/_layout/t/$slug/viewers/settings'
      path: '/t/$slug/viewers/settings'
      fullPath: '/t/$slug/viewers/settings'
      preLoaderRoute: typeof tViewersSettingsRouteImport
      parentRoute: typeof tLayoutRoute
    }
    '/_layout/t/$slug/sites/$siteId/pages/$pageId': {
      id: '/_layout/t/$slug/sites/$siteId/pages/$pageId'
      path: '/t/$slug/sites/$siteId/pages/$pageId'
      fullPath: '/t/$slug/sites/$siteId/pages/$pageId'
      preLoaderRoute: typeof tSiteEditorRouteImport
      parentRoute: typeof tLayoutRoute
    }
  }
}

interface tLayoutRouteChildren {
  tDashboardRoute: typeof tDashboardRoute
  tAiRoute: typeof tAiRoute
  tAnalyticsRoute: typeof tAnalyticsRoute
  tArchiveRoute: typeof tArchiveRoute
  tCatchupRoute: typeof tCatchupRoute
  tContributionRoute: typeof tContributionRoute
  tDeliveryRoute: typeof tDeliveryRoute
  tEntitiesRoute: typeof tEntitiesRoute
  tEpgRoute: typeof tEpgRoute
  tFastRoute: typeof tFastRoute
  tHelpRoute: typeof tHelpRoute
  tIntegrationsRoute: typeof tIntegrationsRoute
  tLibraryRoute: typeof tLibraryRoute
  tLiveRoute: typeof tLiveRoute
  tMonitoringRoute: typeof tMonitoringRoute
  tPlayersRoute: typeof tPlayersRoute
  tSeriesRoute: typeof tSeriesRoute
  tSettingsRoute: typeof tSettingsRoute
  tSitesRoute: typeof tSitesRoute
  tStorageRoute: typeof tStorageRoute
  tSupportRoute: typeof tSupportRoute
  tTeamRoute: typeof tTeamRoute
  tViewersRoute: typeof tViewersRoute
  tHelpTopicRoute: typeof tHelpTopicRoute
  tAssetRoute: typeof tAssetRoute
  tTrashRoute: typeof tTrashRoute
  tChannelRoute: typeof tChannelRoute
  tPlayersCrashesRoute: typeof tPlayersCrashesRoute
  tPlayersTvRoute: typeof tPlayersTvRoute
  tSupportRequestRoute: typeof tSupportRequestRoute
  tViewerRoute: typeof tViewerRoute
  tViewersAuditRoute: typeof tViewersAuditRoute
  tViewersRequestsRoute: typeof tViewersRequestsRoute
  tViewersSegmentsRoute: typeof tViewersSegmentsRoute
  tViewersSettingsRoute: typeof tViewersSettingsRoute
  tSiteEditorRoute: typeof tSiteEditorRoute
}

const tLayoutRouteChildren: tLayoutRouteChildren = {
  tDashboardRoute: tDashboardRoute,
  tAiRoute: tAiRoute,
  tAnalyticsRoute: tAnalyticsRoute,
  tArchiveRoute: tArchiveRoute,
  tCatchupRoute: tCatchupRoute,
  tContributionRoute: tContributionRoute,
  tDeliveryRoute: tDeliveryRoute,
  tEntitiesRoute: tEntitiesRoute,
  tEpgRoute: tEpgRoute,
  tFastRoute: tFastRoute,
  tHelpRoute: tHelpRoute,
  tIntegrationsRoute: tIntegrationsRoute,
  tLibraryRoute: tLibraryRoute,
  tLiveRoute: tLiveRoute,
  tMonitoringRoute: tMonitoringRoute,
  tPlayersRoute: tPlayersRoute,
  tSeriesRoute: tSeriesRoute,
  tSettingsRoute: tSettingsRoute,
  tSitesRoute: tSitesRoute,
  tStorageRoute: tStorageRoute,
  tSupportRoute: tSupportRoute,
  tTeamRoute: tTeamRoute,
  tViewersRoute: tViewersRoute,
  tHelpTopicRoute: tHelpTopicRoute,
  tAssetRoute: tAssetRoute,
  tTrashRoute: tTrashRoute,
  tChannelRoute: tChannelRoute,
  tPlayersCrashesRoute: tPlayersCrashesRoute,
  tPlayersTvRoute: tPlayersTvRoute,
  tSupportRequestRoute: tSupportRequestRoute,
  tViewerRoute: tViewerRoute,
  tViewersAuditRoute: tViewersAuditRoute,
  tViewersRequestsRoute: tViewersRequestsRoute,
  tViewersSegmentsRoute: tViewersSegmentsRoute,
  tViewersSettingsRoute: tViewersSettingsRoute,
  tSiteEditorRoute: tSiteEditorRoute,
}

const tLayoutRouteWithChildren =
  tLayoutRoute._addFileChildren(tLayoutRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  indexRoute: indexRoute,
  tLayoutRoute: tLayoutRouteWithChildren,
  connectRoute: connectRoute,
  loginRoute: loginRoute,
  registerRoute: registerRoute,
  devComponentsRoute: devComponentsRoute,
  helpEntryRoute: helpEntryRoute,
  inviteRoute: inviteRoute,
  passwordForgotRoute: passwordForgotRoute,
  passwordResetRoute: passwordResetRoute,
  registerVerifyRoute: registerVerifyRoute,
  resetTokenRoute: resetTokenRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
